/*
export class FiImageSize {
    static Thumbnail = 'Thumbnail'; // 75 75 16 .jpg
    static Large = 'Desktop'; // 1200 1200 16 .jpg
    static Medium = 'Post'; // 700 700 16 .jpg
    static Small = 'Document'; // 400 400 16 .jpg

    // todo: remove all variables below
    // static Smartphone = 'Smartphone'; // 480 480 16 .jpg
    // static Tablet = 'Tablet'; // 640 640 16 .jpg

    static AttachmentPreview = 'AttachmentPreview'; // 150 150 16 .jpg
    // static List = 'List'; // 32 32 16 .jpg
    // static Grid = 'Grid'; // 130 130 16 .jpg;
    // static StartPagePreview = 'StartPagePreview' //160 160 16 .jpg

    static Logo = 'Logo' //192 192 16 .jpg
    static Background = 'Background' //1920 1200 16 .jpg
}*/

export enum FiImageSize {
    Original = 0,
    Thumbnail = 1, // 75 75 16 .jpg
    Large = 2, // 1200 1200 16 .jpg
    Medium = 3, // 700 700 16 .jpg
    Small = 4, // 400 400 16 .jpg

    AttachmentPreview = 5, // 150 150 16 .jpg // todo should be removed at the end of FI-4277 task

    Logo = 10, //192 192 16 .jpg
    Background = 11, //1920 1200 16 .jpg
}

export enum FiAttachmentDisplaySize {
    Small = 'display-size-small-attachment', // max-height: 80px; max-width: max-content;
    Medium = 'display-size-medium-attachment', // max-height: 120px; max-width:  max-content;
}
